export default __webpack_public_path__ + "static/media/followed_icon.62cab004.svg";